import React from 'react';
import DefaultLogo from '@assets/images/logo.png';
import { useBrandLogo } from '@theme';

type BrandLogoProps = {
    alt?: string;
    className?: string;
    style?: React.CSSProperties;
    width?: number | string;
};

const BrandLogo: React.FC<BrandLogoProps> = ({
    alt = 'Khaata POS',
    className,
    style,
    width,
}) => {
    const logoSrc = useBrandLogo(DefaultLogo);

    return (
        <img
            src={logoSrc}
            alt={alt}
            className={className}
            style={{ width, ...style }}
        />
    );
};

export default BrandLogo;
